export default {
  login: "Heckles44",
  id: 62481529,
  node_id: "MDQ6VXNlcjYyNDgxNTI5",
  avatar_url: "https://avatars0.githubusercontent.com/u/62481529?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/Heckles44",
  html_url: "https://github.com/Heckles44",
  followers_url: "https://api.github.com/users/Heckles44/followers",
  following_url:
    "https://api.github.com/users/Heckles44/following{/other_user}",
  gists_url: "https://api.github.com/users/Heckles44/gists{/gist_id}",
  starred_url: "https://api.github.com/users/Heckles44/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/Heckles44/subscriptions",
  organizations_url: "https://api.github.com/users/Heckles44/orgs",
  repos_url: "https://api.github.com/users/Heckles44/repos",
  events_url: "https://api.github.com/users/Heckles44/events{/privacy}",
  received_events_url: "https://api.github.com/users/Heckles44/received_events",
  type: "User",
  site_admin: false,
  name: "David Ballock",
  company: null,
  blog: "https://my-portfolio-ballock.netlify.app/",
  location: "Melbourne, Australia",
  email: null,
  hireable: null,
  bio: "Self-taught Developer",
  twitter_username: "DavidBallock",
  public_repos: 24,
  public_gists: 0,
  followers: 1,
  following: 4,
  created_at: "2020-03-21T18:46:06Z",
  updated_at: "2020-12-01T02:05:17Z",
};
